import axios from "axios";
import "../../../setup/config/apiConfig";

export const GET_CONTRACT_INVOICES = "GET_CONTRACT_INVOICES";
export const GET_CONTRACT_INVOICES_RESPONSE = "GET_CONTRACT_INVOICES_RESPONSE";
export const GET_CONTRACT_INVOICES_FAIL = "GET_CONTRACT_INVOICES_FAIL";

export const GET_CONTRACT_INVOICE_ACCOUNTS = "GET_CONTRACT_INVOICE_ACCOUNTS";
export const GET_CONTRACT_INVOICE_ACCOUNTS_RESPONSE = "GET_CONTRACT_INVOICE_ACCOUNTS_RESPONSE";
export const GET_CONTRACT_INVOICE_ACCOUNTS_FAIL = "GET_CONTRACT_INVOICE_ACCOUNTS_FAIL";

export function getContractInvoices(isLoading = true, sortBy = null, sortOrder = null) {
  return (dispatch) => {
    dispatch({
      type: GET_CONTRACT_INVOICES,
      isLoading: isLoading,
    });

    const params = {};
    if (sortBy) {
      params.sortBy = sortBy;
    }
    if (sortOrder) {
      params.sortOrder = sortOrder;
    }

    return axios
      .get("/contract-invoice", { params })
      .then((res) => {
        dispatch({
          type: GET_CONTRACT_INVOICES_RESPONSE,
          contractInvoices: res.data,
          isLoading: false,
          error: null,
        });
        return res.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_CONTRACT_INVOICES_FAIL,
          isLoading: false,
          error: error.message || "Failed to fetch contract invoices",
        });
      });
  };
}

export function getContractInvoiceAccounts(isLoading = true, sortBy = null, sortOrder = null) {
  return (dispatch) => {
    dispatch({
      type: GET_CONTRACT_INVOICE_ACCOUNTS,
      isLoading: isLoading,
    });

    const params = {};
    if (sortBy) {
      params.sortBy = sortBy;
    }
    if (sortOrder) {
      params.sortOrder = sortOrder;
    }

    return axios
      .get("/contract-invoice-account", { params })
      .then((res) => {
        dispatch({
          type: GET_CONTRACT_INVOICE_ACCOUNTS_RESPONSE,
          contractInvoiceAccounts: res.data,
          isLoading: false,
          error: null,
        });
        return res.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_CONTRACT_INVOICE_ACCOUNTS_FAIL,
          isLoading: false,
          error: error.message || "Failed to fetch contract invoice accounts",
        });
      });
  };
}


export function getSignedUrl(key) {
  if (!key || typeof key !== "string" || !key.trim()) {
    return Promise.reject(new Error("Missing or invalid key"));
  }
  return axios
    .get("/report/signed-url", { params: { key: key.trim() } })
    .then((res) => ({ signedUrl: res.data.signedUrl }));
}
